import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import { colors } from '~/packages/common-frontend/colors';
import { Icon } from '~/packages/common-frontend/components/icons';
import { AdjustCurrentLiabilitiesModal } from '~/packages/monthlyStatement/AdjustLiabilityButtonTransactions';

export const TransactionsSettingsMenu = ({
  startDate,
  endDate,
}: {
  startDate: Util.FullDateStr;
  endDate: Util.FullDateStr;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Menu>
      <MenuButton>
        <Icon icon="ellipsis-vertical" />
      </MenuButton>
      <MenuList>
        <MenuItem onClick={onOpen} color={colors.gray[800]}>
          Adjust Liabilities
          <AdjustCurrentLiabilitiesModal
            minDate={commonDate.fullDateStrToDate(startDate)}
            maxDate={commonDate.fullDateStrToDate(endDate)}
            setIsTableLoading={() => false}
            isOpen={isOpen}
            onClose={onClose}
          />
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
